/**
 * Modal Store - Global state for modals
 */

import { create } from 'zustand'

interface InsufficientCreditsModalState {
  isOpen: boolean
  currentBalance: number
  requiredBalance: number
  shortfall: number
  onConfirm?: () => void
  onCancel?: () => void
}

interface ModalStore extends InsufficientCreditsModalState {
  openInsufficientCreditsModal: (params: {
    currentBalance: number
    requiredBalance: number
    shortfall: number
    onConfirm?: () => void
    onCancel?: () => void
  }) => void
  closeModal: () => void
}

export const useModalStore = create<ModalStore>((set) => ({
  // Initial state
  isOpen: false,
  currentBalance: 0,
  requiredBalance: 0,
  shortfall: 0,
  onConfirm: undefined,
  onCancel: undefined,

  // Actions
  openInsufficientCreditsModal: (params) => {
    set({
      isOpen: true,
      currentBalance: params.currentBalance,
      requiredBalance: params.requiredBalance,
      shortfall: params.shortfall,
      onConfirm: params.onConfirm,
      onCancel: params.onCancel,
    })
  },

  closeModal: () => {
    set({
      isOpen: false,
      currentBalance: 0,
      requiredBalance: 0,
      shortfall: 0,
      onConfirm: undefined,
      onCancel: undefined,
    })
  },
}))
